/**
 * @author Yash Soni
 * @author Ivan Torres
 */
import { __assign } from "tslib";
/* eslint import/prefer-default-export: 0 */
import { createTheme, LightTheme as BaseuiTheme, lightThemePrimitives as primitives } from '../baseui';
import { sharedPrimitives } from './shared';
export var LightTheme = __assign(__assign({}, createTheme(__assign(__assign({}, primitives), sharedPrimitives))), { name: 'light', colors: BaseuiTheme.colors });
